import * as React from "react";
import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { AccountAdviceType } from "../../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { AssetClassType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ModelPortfolioTabType } from "../../../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { OrderType } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderType";

import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { PropositionInvestmentConfig } from "../../../../../../../Wrap/Models/Domains/Account/PropositionInvestmentConfig";
import { AccountStatus } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { DecisionMaker } from "../../../../../../Shared/IST/Components/DecisionMaker";
import { SearchTabs } from "../../../../../../Shared/IST/Components/Shared/SearchTabs";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { SelectedInvestmentStore } from "../../../../../../Shared/IST/Store/Variable";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../../../Actions/Action";
import { ClientAccountStore, UserStore, TreasuredAssetsStore } from "../../../../../Stroes/Variable";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { InvestmentsAction } from "../../../PortfolioDashboard/Components/Investment/Action/InvestmentAction";
import { BuySellAllocationTable } from "../../../Common/BuySellInvestmentSelection/BuySellAllocationTable";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { hasDecisionMaker } from "../../Resource/Content";
import { InvestmentType } from "../../../../../../../Wrap/Constants/Enums/InvestmentType";
import { InvestorType } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { DepositProduct } from "../../../../../../../Wrap/Models/Domains/Investment/DepositProduct";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { InstrumentSearchQuery } from "../../../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { param } from "jquery";
import { SwitchOrderSetupReview } from "../../../Common/Review/Component/SwitchOrderSetupReview";
import { InvestmentPathwayAnswerSelection } from "../../../Common/SIPP/DrawdownDetails/InvestmentPathwayAnswerSelection";

interface ISwitchToInvestmentProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface ISwitchToInvestmentState {
    isLoading: boolean;
    orderType: OrderType;
    totalValue: number;
    status: AccountStatus;
    investmenPermission: PropositionInvestmentConfig[];
    userInfo: User;
    treasuredAssetProductIds: Array<number>;
    applyEvenWeight: boolean;
    companyServicePropostion: ServiceProposition[];
    depositProducts: Record<number, DepositProduct>;
    instrumentDetails: Record<number, Instrument>;
    unitPrices: Record<number, number>;
    extraInstrumentSearch: any[];
}

export class SwitchToInvestment extends ProcessComponent<ISwitchToInvestmentProps, ISwitchToInvestmentState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            isLoading: true,
            orderType: OrderType.Percentage,
            totalValue: 0,
            investmenPermission: [],
            status: null,
            treasuredAssetProductIds: null,
            applyEvenWeight: false,
            companyServicePropostion: [],
            depositProducts: [],
            instrumentDetails: {},
            unitPrices: {},
            extraInstrumentSearch: [],
        };
        this.subscribeToStore(SelectedInvestmentStore, () => this.onStoreChange());
    }

    private getTreasuredAssets() {
        const _treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();

        if (!_treasuredAssetProductIds) {
            const params = getQueryParameters();

            Action.getSubAccountTreasuredAssetsProductIds(params["subaccounthierarchyid"], (data: Array<number>) => {
                this.setState({ treasuredAssetProductIds: data });
            });
        } else {
            this.setState({ treasuredAssetProductIds: _treasuredAssetProductIds });
        }
    }

    private getTotalSwitchValue(): number {
        const sellAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.SellAllocations || [];
        return Math.round(sellAllocations.reduce(
            (total, allocation) => total + (allocation.Value?.Amount || 0),
            0
        ) * 100) / 100;
    }

    private allocateInvestmentPathway() {
        const selectedPathwayId = this.props.data?.Contribution?.InvestmentPathwayAnswers?.SelectedPathwayId;
        if (!selectedPathwayId || selectedPathwayId == 0) return;

        const productId = this.props.data?.Contribution?.InvestmentPathwaysSettingsForSettings?.find(ele =>
            ele.InvestmentPathwayQuestionSettingOptionId == selectedPathwayId
        )?.SelectedInstrumentId;
        const buyAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations ?? [];
        if (buyAllocations.length != 1 || buyAllocations[0].ProductId != productId || buyAllocations[0].Percentage == 100) return;

        this.updateSwitchModel([{ ...buyAllocations[0], Percentage: 100 }])
    }

    componentDidUpdate(prevProps: any): void {
        super.componentDidUpdate(prevProps);
        this.allocateInvestmentPathway();
    }

    componentDidMount() {
        super.componentDidMount();
        this.getTreasuredAssets();
        InvestmentSelectionAction.setIsUnderTransfer(true);
        const params = getQueryParameters();
        const clientAccount = ClientAccountStore.getClientAccountInfo();

        const totalValue = this.getTotalSwitchValue();

        const buyAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations || [];

        if (clientAccount?.AccountServicePropositionId) {
            InvestmentSelectionAction.getInvestmentPermission(clientAccount.AccountServicePropositionId, (res) => {
                const newRes = [...res];
                const elementIndex = newRes.findIndex((x) => x.InvestmentTypeId == InvestmentType.CashDeposits);
                if (elementIndex !== -1) {
                    newRes[elementIndex].Enable = (clientAccount.InvestorType == InvestorType.Individ ||
                        clientAccount.InvestorType == InvestorType.Individual ||
                        clientAccount.InvestorType == InvestorType.Joint ||
                        clientAccount.InvestorType == InvestorType.JointIndividual)
                }
                this.setState({ investmenPermission: newRes });
            });
        }
        if (clientAccount?.Company) {
            CompanyWizardAction.getViewCompany(clientAccount?.Company, (res) => {
                this.setState({ companyServicePropostion: res?.ServicePropositions });
            });
        }

        BuyAction.getReuseHoldings(
            params["hierarchyid"],
            params["subaccounthierarchyid"],
            0,
            (data: ClientTradableInvestments) => {
                this.setState({ status: data.AccountStatus });
                this.props.onChange({
                    AccountAdviceType: data.ClientDetail
                        ? data.ClientDetail.AccountAdviceType
                        : AccountAdviceType.NotSpecified
                });
            }
        )

        if (buyAllocations.length > 0) {
            this.loadInstrumentDetails(buyAllocations).then(() => {
                this.loadUnitPrices(buyAllocations).then(() => {
                    this.setState({ isLoading: false, totalValue });
                });
            });
        } else {
            this.setState({ isLoading: false, totalValue });
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        InvestmentSelectionAction.setIsUnderTransfer(false);
    }

    isValid() {
        if (this.state.isLoading) return false;
        if (RestrictionStore.buyDisabled() || RestrictionStore.sellDisabled()) return false;

        const totalPercentage = this.props.data.Contribution.SwitchInstructionModel.BuyAllocations.reduce((sum, inv) => sum + inv.Percentage, 0);

        if (Math.abs(totalPercentage - 100) > 0.01) {
            this.props.showErrorMsgPopUp(["Price of investments not matching the total value"]);
            return false;
        }

        const flag = super.isValid();
        if (this.state.status != AccountStatus.Active) {
            this.props.showErrorMsgPopUp(["The account is in active!"]);
        }

        const isValid = flag && this.state.status == AccountStatus.Active;

        if (isValid) {
            const params = getQueryParameters();
            InvestmentsAction.setSubAccountTreasuredAssetsProductIds(
                params["subaccounthierarchyid"],
                this.state.treasuredAssetProductIds || []
            );
        }

        return isValid;
    }

    onStoreChange() {
        if (SelectedInvestmentStore.getActionType() == ActionType.Success) {
            const selectedInvestments = SelectedInvestmentStore.getData();

            const currentBuyAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations || [];

            const instrumentDetails = { ...this.state.instrumentDetails };
            const extraInstrumentSearch = this.state.extraInstrumentSearch;
            const unitPrices = { ...this.state.unitPrices };

            const selectedPathwayId = this.props.data?.Contribution?.InvestmentPathwayAnswers?.SelectedPathwayId;
            const pathwayProductId = this.props.data?.Contribution?.InvestmentPathwaysSettingsForSettings?.find(ele =>
                ele.InvestmentPathwayQuestionSettingOptionId == selectedPathwayId
            )?.SelectedInstrumentId;

            let newBuyAllocations = [...currentBuyAllocations];

            let extraInvestment = selectedInvestments[0];
            if (extraInvestment?.IsFromExtraSearch 
                && extraInstrumentSearch.findIndex((x) => x.ProductId == extraInvestment.Investment.ProductId) == -1
                && extraInvestment?.Investment?.ProductId != pathwayProductId) {
                extraInstrumentSearch.push(extraInvestment);
            }

            if (!extraInvestment?.IsFromExtraSearch || extraInvestment?.Investment?.ProductId == pathwayProductId){
                selectedInvestments.forEach(item => {
                    const investment = item.Investment;
                    instrumentDetails[investment.ProductId] = investment;

                    const percentage = investment.Allocation
                    const quantity = this.getQuanty(investment, percentage);

                    if (newBuyAllocations.findIndex(ext => ext.ProductId == investment.ProductId) == -1) {
                        newBuyAllocations.push({
                            ProductId: investment.ProductId,
                            ProductCode: investment.InstrumentCode || "",
                            Name: investment.DisplayName,
                            Type: investment.Type,
                            Percentage: percentage,
                            Value: { Amount: percentage > 0 ? Number((this.state.totalValue * (percentage / 100)).toFixed(2)) : 0, Currency: CurrencyCode.GBP },
                            Quantity: quantity,
                            modelPortfolioType: item.modelPortfolioType,
                            underlying: item?.underlying,
                        });    
                    }           
                });
            }

            extraInstrumentSearch.map((val, idx) => {
                if (newBuyAllocations.findIndex(ext => ext.ProductId == val.Investment.ProductId) == -1) {
                    newBuyAllocations.push({
                        ProductId: val.Investment.ProductId,
                        ProductCode: val.Investment.ProductCode || "",
                        Name: val.Investment.DisplayName,
                        Type: val.Investment.Type,
                        Percentage: val.Investment.Allocation,
                        Value: { Amount: 0, Currency: CurrencyCode.GBP },
                        Quantity: val.Investment.UnitPrice,
                    });
                }
            });

            this.setState({
                instrumentDetails,
                extraInstrumentSearch,
                unitPrices
            });

            this.updateSwitchModel(newBuyAllocations);
        }
    }

    private loadInstrumentDetails(allocations: any[]): Promise<void> {
        return new Promise((resolve) => {
            if (!allocations || allocations.length === 0) return;

            const productIds = allocations.map(a => a.ProductId);
            const idsToFetch = productIds.filter(id => !this.state.instrumentDetails[id]);

            if (idsToFetch.length === 0) return;

            this.setState({ isLoading: true });

            const params = getQueryParameters();
            const query: InstrumentSearchQuery = {
                ProductWrapperTypes: [this.props.type],
                ProductIds: idsToFetch,
                ResultsPerPage: idsToFetch.length,
            };

            InvestmentSelectionAction.searchInstruments(
                query,
                params["subaccounthierarchyid"],
                (result: Instrument[]) => {
                    if (result && result.length > 0) {
                        const instrumentDetails = { ...this.state.instrumentDetails };

                        result.forEach(instrument => {
                            instrumentDetails[instrument.ProductId] = instrument;
                        });

                        this.setState({
                            instrumentDetails,
                            isLoading: false
                        }, () => {
                            this.updateBuyAllocationsWithDetails();
                            resolve();
                        });
                    } else {
                        this.setState({ isLoading: false });
                    }
                }
            );
        });
    }

    private getQuanty(instrument: any, percentage: number): number {
        percentage = Number(percentage || 0);
        const value = Number((this.state.totalValue * (percentage / 100)).toFixed(2));

        const cachedUnitPrice = this.state.unitPrices[instrument.ProductId];
        const itemUnitPrice = instrument.UnitPrice?.Amount;
        const unitPrice = cachedUnitPrice || itemUnitPrice || 1;

        let quantity = 0;
        if (unitPrice && unitPrice > 0 && value > 0) {
            quantity = Number((value / unitPrice).toFixed(4));
        }

        return quantity;
    }

    private loadUnitPrices(allocations: any[]): Promise<void> {
        return new Promise((resolve) => {
            if (!allocations || allocations.length === 0) return;

            const allocationsToFetch = allocations.filter(a => {
                if (this.state.unitPrices[a.ProductId]) return false;

                return this.state.instrumentDetails[a.ProductId]?.ProductCode;
            });

            if (allocationsToFetch.length === 0) return;

            this.setState({ isLoading: true });

            let completed = 0;

            const unitPrices = { ...this.state.unitPrices };

            allocationsToFetch.forEach(allocation => {
                InvestmentSelectionAction.getUnitPrice(
                    { ProductId: allocation.ProductId, ProductCode: this.state.instrumentDetails[allocation.ProductId]?.ProductCode },
                    (result) => {
                        completed++;

                        if (result?.UnitPrice?.Amount) {
                            unitPrices[allocation.ProductId] = result.UnitPrice.Amount;
                        }

                        if (completed === allocationsToFetch.length) {
                            this.setState({
                                unitPrices,
                                isLoading: false
                            }, () => {
                                this.updateBuyAllocationsWithQuantitiesAndValues();
                                resolve();
                            });
                        }
                    }
                );
            });
        });
    }

    private updateBuyAllocationsWithDetails() {
        const buyAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations || [];
        let hasUpdates = false;

        const updatedAllocations = buyAllocations.map(allocation => {
            const instrument = this.state.instrumentDetails[allocation.ProductId];
            const modelPortfolioType =
                this.state.orderType !== OrderType.Quantity ? InvestmentType.HubPortfolios : null;

            if (instrument) {
                if (!allocation.Name || allocation.Type === 0) {
                    hasUpdates = true;
                    return {
                        ...allocation,
                        Name: instrument.Name,
                        Type: instrument.Type,
                        ProductCode: instrument.ProductCode,
                        needToggle: modelPortfolioType == InvestmentType.HubPortfolios,
                        modelPortfolioType: modelPortfolioType,
                    };
                }
            }

            return allocation;
        });

        if (hasUpdates) {
            this.props.onChange({
                Contribution: {
                    ...this.props.data.Contribution,
                    SwitchInstructionModel: {
                        ...this.props.data.Contribution.SwitchInstructionModel,
                        BuyAllocations: updatedAllocations
                    }
                }
            });
        }
    }

    private updateBuyAllocationsWithQuantitiesAndValues() {
        const buyAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations || [];
        let hasUpdates = false;
        const totalAmount = this.getTotalSwitchValue();

        const updatedAllocations = buyAllocations.map(allocation => {
            const unitPrice = this.state.unitPrices[allocation.ProductId];

            if (unitPrice && unitPrice > 0 && allocation.Percentage > 0) {
                hasUpdates = true;
                const newValue = totalAmount * allocation.Percentage / 100;
                const newQuantity = Number((newValue / unitPrice).toFixed(4));

                return {
                    ...allocation,
                    Quantity: newQuantity,
                    Value: { Amount: newValue, Currency: CurrencyCode.GBP }
                };
            }

            return allocation;
        });

        if (hasUpdates) {
            this.updateSwitchModel(updatedAllocations);
        }
    }

    private updateSwitchModel(buyAllocations) {
        this.props.onChange({
            Contribution: {
                ...this.props.data.Contribution,
                SwitchInstructionModel: {
                    ...this.props.data.Contribution.SwitchInstructionModel,
                    BuyAllocations: buyAllocations
                }
            }
        });
    }

    private onTreasuredAssetChange = (v: boolean, productId: number) => {
        const treasuredAssets = new Set(this.state.treasuredAssetProductIds);
        let stateHasChanged = false;

        if (treasuredAssets.has(productId)) {
            if (!v) {
                treasuredAssets.delete(productId);
                stateHasChanged = true;
            }
        } else {
            if (v) {
                treasuredAssets.add(productId);
                stateHasChanged = true;
            }
        }

        if (stateHasChanged) {
            this.setState({ treasuredAssetProductIds: Array.from(treasuredAssets) });
        }
    };

    private applyEven = (v) => {
        if (!v) return;

        const buyAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations || [];
        if (buyAllocations.length === 0) return;

        const totalValue = this.getTotalSwitchValue();
        const evenPercentage = Number((100 / buyAllocations.length).toFixed(2));
        const lastPercentage = Number((100 - evenPercentage * (buyAllocations.length - 1)).toFixed(2));

        const updatedBuyAllocations = buyAllocations.map((allocation, index) => {
            const percentage = index === buyAllocations.length - 1 ? lastPercentage : evenPercentage;
            const value = Number((totalValue * (percentage / 100)).toFixed(2));

            // Calculate quantity using stored unit price
            const unitPrice = this.state.unitPrices[allocation.ProductId];
            let quantity = 0;

            if (unitPrice && unitPrice > 0 && value > 0) {
                quantity = Number((value / unitPrice).toFixed(4));
            }

            return {
                ...allocation,
                Percentage: percentage,
                Value: { Amount: value, Currency: CurrencyCode.GBP },
                Quantity: quantity
            };
        });

        this.updateSwitchModel(updatedBuyAllocations);
        this.setState({ applyEvenWeight: true });
    }

    // TODO
    private onUnderlyingToggle(isToggle, index, row) {
        const _data = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations.concat();
        if (isToggle) {
            const item = _data[index];
            _data[index].isToggle = isToggle;
            if (item.underlying) {
                this.updateSwitchModel(_data);
            } else {
                if (row.modelPortfolioType) {
                    InvestmentSelectionAction.getUnderlying(
                        row.Instrument.ProductId,
                        ModelPortfolioTabType.HubModel,
                        (data) => {
                            _data[index].underlying = data;
                            this.updateSwitchModel(_data);
                        }
                    );
                } else {
                    InvestmentsAction.getInvestmentsModelSingle(
                        getQueryParameters()["subaccounthierarchyid"],
                        row.Instrument.InstrumentCode,
                        JsonDateParser.toJsonDateNoOffset(new Date()),
                        AssetClassType.Tier1,
                        (result) => {
                            _data[index].underlying = { ModelPortfolioProducts: [] };
                            result.forEach((ele) => {
                                ele.Investments.forEach((item) => {
                                    _data[index].underlying.ModelPortfolioProducts.push({
                                        name: item.DisplayName,
                                        targetAllocation: "-",
                                    });
                                });
                            });
                            this.updateSwitchModel(_data);
                        }
                    );
                }
            }
        } else {
            _data[index].isToggle = isToggle;
            this.updateSwitchModel(_data);
        }
    }

    private onInvestPathwayChange(v) {
        this.props.onChange({
            Contribution: {
                ...this.props.data.Contribution,
                InvestmentPathwayAnswers: v.InvestmentPathwayAnswers
            }
        });
    }

    private onCurrentPathwayChange = (text: string | null) => {
        this.props.onChange({ selectedPathwayText: text });
    }

    public render(): JSX.Element {
        const { data, type, onChange } = this.props;
        const totalValue = this.getTotalSwitchValue();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        const params = getQueryParameters();

        let restrictedMessage = "An account with suspended or restricted activities cannot setup switch to investments";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        const buyAllocations = this.props.data?.Contribution?.SwitchInstructionModel?.BuyAllocations || [];
        const tableData = buyAllocations.map(allocation => {
            const instrument = this.state.instrumentDetails[allocation.ProductId];
            const unitPrice = this.state.unitPrices[allocation.ProductId];
            let displayUnitPrice = { Amount: 0, Currency: CurrencyCode.GBP };
            if (unitPrice) {
                displayUnitPrice.Amount = unitPrice;
            } else if (allocation.Quantity && allocation.Quantity > 0 && allocation.Value?.Amount) {
                displayUnitPrice.Amount = allocation.Value.Amount / allocation.Quantity;
            }

            return {
                Instrument: {
                    ProductId: allocation.ProductId,
                    DisplayName: instrument?.Name || allocation.Name,
                    Type: allocation.Type || (instrument?.Type || 0),
                    InstrumentCode: instrument?.ProductCode || allocation.ProductCode,
                    UnitPrice: displayUnitPrice
                },
                InstrumentCode: instrument?.ProductCode || allocation.ProductCode,
                OrderValue: allocation.Value?.Amount || 0,
                OrderPercentage: allocation.Percentage || 0,
                Type: allocation.Type,
                tradeable: true,
                isSellAll: false,
                isLimit: false,
                OrderLimit: undefined,
                ExpiryDate: undefined,
                modelPortfolioType: allocation?.modelPortfolioType,
                underlying: allocation?.underlying
            };
        });

        return (
            <div className="ist-wrap">
                <h2 className="mb-18">
                    <span>Switch to investments</span>
                </h2>
                {(RestrictionStore.buyDisabled() || RestrictionStore.sellDisabled()) && (
                    <Alert alertType={AlertType.Error} message={restrictedMessage} />
                )}
                <SwitchOrderSetupReview data={data} subAccountType={type} process={ProcessType.Buy} colNum={1} />
                <NumberTextBoxEditor
                    disabled
                    label="Total order value"
                    cssWrapper="control-size-430"
                    value={totalValue}
                    onChange={() => { }}
                    maxNumberOfDecimalPlaces={{
                        errorMessage: "only allow two decimal places",
                        value: 2,
                    }}
                    required="Please enter"
                />
                <hr />
                {this.props.type == SubAccountType.Npr &&
                    <InvestmentPathwayAnswerSelection
                        onRef={(ref) => this.appendChild(ref)}
                        data={data}
                        onChange={() => { }}
                        onInvestPathwayChange={(v) => this.onInvestPathwayChange(v)}
                        onCurrentPathwayChange={(v) => this.onCurrentPathwayChange(v)}
                    />
                }
                <PartLoading isLoading={this.state.isLoading}>
                    <SearchTabs
                        hiercharyId={params["subaccounthierarchyid"]}
                        product={type}
                        data={buyAllocations}
                        isUnderTransfer={false}
                        isUnderSwitch={true}
                        isUnit={this.state.orderType == OrderType.Quantity}
                        investmentPermission={this.state.investmenPermission}
                        accountServiceProposition={clientAccount?.AccountServicePropositionId}
                        canBeBought={true}
                        canBeSold={false}
                        companyServiceProposition={this.state.companyServicePropostion}
                        selectedPathwayText={data.selectedPathwayText}
                    />
                    <div className="row mt-5">
                        <div className="col-6">
                            {this.state.orderType == OrderType.Percentage && (
                                <CheckboxEditor
                                    label="Apply even weighting"
                                    cssWrapper="square-checkbox block mt-20"
                                    value={this.state.applyEvenWeight}
                                    onChange={(v) => this.applyEven(v)}
                                />
                            )}
                        </div>
                    </div>
                    <BuySellAllocationTable
                        onToggle={(isToggle, index, rowData) => this.onUnderlyingToggle(isToggle, index, rowData)}
                        data={tableData}
                        orderType={this.state.orderType}
                        onChange={(updatedList) => {

                            updatedList.forEach(item => {
                                if (item.Instrument?.UnitPrice?.Amount) {
                                    const unitPrices = { ...this.state.unitPrices };
                                    unitPrices[item.Instrument.ProductId] = item.Instrument.UnitPrice.Amount;
                                    this.setState({ unitPrices });
                                }
                            });

                            const updatedBuyAllocations = updatedList.map(item => {
                                const percentage = Number(item.OrderPercentage || 0);
                                const value = Number((this.state.totalValue * (percentage / 100)).toFixed(2));
                                const quantity = this.getQuanty(item.Instrument, percentage);

                                return {
                                    ProductId: item.Instrument.ProductId,
                                    ProductCode: item.Instrument.InstrumentCode,
                                    Name: item.Instrument.DisplayName,
                                    Type: item.Instrument.Type,
                                    Percentage: percentage,
                                    Value: { Amount: value, Currency: CurrencyCode.GBP },
                                    Quantity: quantity,
                                    modelPortfolioType: item?.modelPortfolioType,
                                    underlying: item?.underlying,
                                };
                            });

                            this.updateSwitchModel(updatedBuyAllocations);

                        }}
                        excludeLimit
                        process={ProcessType.Buy}
                        onRef={(ref) => this.appendChild(ref)}
                        totalValue={totalValue}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onTreasuredAssetChange={this.onTreasuredAssetChange}
                        ChecktreasuredAsset={this.state.treasuredAssetProductIds}
                        depositProducts={this.state.depositProducts}
                        batchType={data.BatchType}
                    />
                    {/* TODO: fix decision maker */}
                    {hasDecisionMaker(data.BuyInvestmentList) && (
                        <DecisionMaker
                            onRef={(ref) => this.appendChild(ref)}
                            data={data}
                            onChange={(v) => onChange(v)}
                            clAccountId={params["claccountid"]}
                            headAccountHierarchyId={clientAccount?.HierarchyId}
                            companyCode={clientAccount?.Company}
                            accountAdviceType={
                                clientAccount?.Discretionary
                                    ? AccountAdviceType.Discretionary
                                    : AccountAdviceType.NonDiscretionary
                            }
                        />
                    )}
                </PartLoading>
            </div>
        );
    }
}
